import React from 'react';
import { ProductType } from '@/@types';
import { UIComponent } from '@/components/core/components';
import { Plural, Trans } from '@lingui/react/macro';
import * as styles from './recommendations.styles';

const Recommendations: UIComponent<{ product: ProductType }> = ({ product }) => {
  return (
    <div className={styles.recommendations}>
      {product.recommendations.total > 0 && (
        <span className={styles.totalRecommendations}>
          <Trans>
            Recommended by <Plural value={product.recommendations.total} one="1 user" other="# users" />
          </Trans>
        </span>
      )}
    </div>
  );
};

export default Recommendations;
